import { h } from 'preact'
import { PureComponent } from 'preact/compat'
import { createDefaultSrc, createPmdSrcSet } from '../pmd/pmd-urls'
import styles from './index.module.css'

type AnimatedImageProps = {
  fileName: string
  sequence: Array<number>
  aspectRatio: number
}

type AnimagedImageState = {
  currentIdx: number
}

export class AnimatedImage extends PureComponent<AnimatedImageProps, AnimagedImageState> {
  observer: any
  element: any
  animationStartTime: number

  constructor() {
    super()
    this.state = { currentIdx: 0 }
  }

  componentDidMount() {
    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
            if (!this.animationStartTime) {
              this.animationStartTime = new Date().getTime()
              this.animate()
            }
          }
        })
      },
      { threshold: [0.8] }
    )
    this.observer.observe(this.element)
  }

  animate() {
    const delay = 600
    const delta = 100

    const loop = () => {
      const now = new Date().getTime()
      const idx = Math.max(0, Math.floor((now - this.animationStartTime - delay) / delta))

      if (this.state.currentIdx !== idx) {
        this.setState({ currentIdx: idx })
      }

      if (this.hasMoreFrames()) {
        requestAnimationFrame(loop)
      }
    }

    loop()
  }

  hasMoreFrames() {
    return this.state.currentIdx < this.props.sequence.length - 1
  }

  render() {
    return (
      <div
        className={styles.animatedImage}
        ref={(element) => {
          this.element = element
        }}
        style={{ width: '100%', paddingBottom: `${this.props.aspectRatio * 100}%` }}
      >
        {this.props.sequence.map((number, idx) => {
          const fileName = this.props.fileName.replace('{{number}}', number.toString())
          const currentNumber = this.props.sequence[this.state.currentIdx]

          return (
            <img
              key={idx}
              src={createDefaultSrc(fileName)}
              srcSet={createPmdSrcSet(fileName)}
              alt=""
              style={{ width: '100%', visibility: currentNumber === number ? 'visible' : 'hidden' }}
            />
          )
        })}
      </div>
    )
  }
}
